import type {CustomDealStockAvailability as CustomDealStockAvailabilityData} from '../../types';

import {ClockCircleOutlined, EditOutlined} from '@ant-design/icons';
import {Card} from '@ds/components';

import {getRemainingDays} from '../../utils';
import CustomDealStockAvailability from '../common/CustomDealStockAvailability/CustomDealStockAvailability';

type CustomDealQueuedCardProps = {
  productCount?: number;
  date: string;
  startDate?: string;
  stockAvailability?: CustomDealStockAvailabilityData;
  onClick: () => void;
};

const CustomDealQueuedCard: React.FC<CustomDealQueuedCardProps> = ({
  productCount,
  date,
  startDate,
  stockAvailability,
  onClick
}) => {
  const remainingDays = getRemainingDays(startDate);

  return (
    <Card
      className="w-full cursor-pointer border-gray-22 shadow-md focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange [&>div]:p-3"
      size="small"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick();
        }
      }}
    >
      <div className="flex flex-col">
        <div className="flex items-center justify-between gap-3">
          <div className="flex flex-col">
            <h3 className="text-body-sm-emphasis text-neutral-fg">{date}</h3>
            <span className="flex items-center gap-1 text-body-sm text-gray-07">
              <span>{productCount ?? 0} کالا</span>
              <span>•</span>
              <ClockCircleOutlined aria-hidden />
              <span>{remainingDays} روز تا شروع</span>
            </span>
          </div>
          <EditOutlined className="text-subtitle-lg text-orange" aria-hidden />
        </div>
        <div className="mx-5 my-2.5">
          <CustomDealStockAvailability stockAvailability={stockAvailability} />
        </div>
      </div>
    </Card>
  );
};

export default CustomDealQueuedCard;
